module.exports = __webpack_public_path__ + "img/list_hk1_2_tc.bad9770d.png";